import { Dispatcher } from '../../lib';
import { KeyHandler } from './handler';

export default new Dispatcher('key-handling', KeyHandler);
